module.exports = {
	BACKEND_HOST: 'https://quizapi.myquizscape.com',
	BACKEND_PORT: '8080',
	SENTRY_URL: 'https://466edddf52624723aacee3ae5b98b482@o132747.ingest.sentry.io/1765988',
}
